//Standard library imports
import React, { useEffect, useState } from 'react';
// External library imports
import { toast } from 'react-toastify';
import { get as lodashGet } from 'lodash';
//Internal module imports
import bidClasses from '../Bidding.module.css';
import Table from '../../../../components/Table/Table';
import Typography from '../../../../components/Typography/Typography';
import { useLoader, useUserRole } from '../../../../hooks';
import { RootBiddingService } from '../../../../services/BiddingService/Root/BiddingService';
import allDeviceClasses from '../../../../styles/AllDevices.module.css';
import { AdminBiddingService } from '../../../../services/BiddingService/Admin/BiddingService';
import { RootBundleBiddingService } from '../../../../services/BiddingService/Root/BundleBiddingService';
import { AdminBundleBiddingService } from '../../../../services/BiddingService/Admin/BundleBiddingService';

const FetchResult = ({ bid, closeModal, bidType }) => {
    const { isRootUser } = useUserRole();
    const service = isRootUser ? (bidType === 'bundle' ? RootBundleBiddingService : RootBiddingService) : bidType === 'bundle' ? AdminBundleBiddingService : AdminBiddingService;
    const [data, setData] = useState([]);
    const [startLoader, stopLoader] = useLoader();

    useEffect(() => {
        if (bid) fetchResult();
    }, []);

    const fetchResult = () => {
        service.FetchResult(bid._id, startLoader, handleSuccess, handleError, stopLoader);
    };

    const handleSuccess = ({ data }) => {
        setData(data.data || []);
    };

    const handleError = (err) => {
        toast.error(lodashGet(err, ['response', 'data', 'message']));
    };

    return (
        <div className={`${bidClasses.InfoModalContainer}`}>
            <div>
                <div className={bidClasses.InfoModalHeading}>
                    <Typography content={'Settlement Bid Status'} size={16} />
                </div>
                <div>
                    <Table head={['Product Name', 'Status']} keys={['productName', 'status']} data={data} />
                </div>
            </div>
            <div className={allDeviceClasses.ButtonContainer}>
                <div>
                    <button type="button" className="btn-secondary" onClick={() => closeModal()}>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FetchResult;
